import { colors, textStyles } from '../../../shared/styles';

export const styles = {
  container: {
    padding: '35px 0',
    borderTop: '1px solid '+ colors.greyLine,
  },
  title: (isMobile) => isMobile ? textStyles.sectionHead : ({
    margin: '0 0 23px',
    fontSize: 18,
    color: colors.textColor,
  }),
};
